require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[49],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(439);


/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _RichTextEditor = _interopRequireDefault(__webpack_require__(440));

exports["default"] = _RichTextEditor["default"];
exports.RichTextEditor = _RichTextEditor["default"];

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactCkeditorComponent = _interopRequireDefault(__webpack_require__(441));

var _utils = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _RichTextEditor = _interopRequireDefault(__webpack_require__(442));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var richtexteditorClassName = _RichTextEditor["default"].richtexteditorClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

var Editor = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Editor, _Component);

  function Editor() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Editor.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        content = _this$props.content,
        config = _this$props.config,
        isScriptLoaded = _this$props.isScriptLoaded,
        scriptUrl = _this$props.scriptUrl,
        events = _this$props.events,
        validationErrorText = _this$props.validationErrorText,
        hasValidationError = _this$props.hasValidationError,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "style", "content", "config", "isScriptLoaded", "scriptUrl", "events", "validationErrorText", "hasValidationError"]);
    var classNames = (0, _utils.classnames)(richtexteditorClassName, {
      error: hasValidationError
    });
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, Editor), {
      className: classNames + " " + className,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_reactCkeditorComponent["default"], {
      content: content,
      config: config,
      isScriptLoaded: isScriptLoaded,
      scriptUrl: scriptUrl,
      events: events,
      activeClass: richtexteditorClassName + "__CKEditor " + this.props.activeClass
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "validation-error"
    }, validationErrorText || '\xa0'));
  };

  return Editor;
}(_react.Component);

exports["default"] = Editor;
(0, _defineProperty2["default"])(Editor, "propTypes", {
  content: _propTypes["default"].any,
  config: _propTypes["default"].object,
  isScriptLoaded: _propTypes["default"].bool,
  scriptUrl: _propTypes["default"].string,
  activeClass: _propTypes["default"].string,
  events: _propTypes["default"].object,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  validationErrorText: _propTypes["default"].string,
  hasValidationError: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(Editor, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

module.exports = require("react-ckeditor-component");

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(443);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-richtexteditor{position:relative;display:inline-block;height:auto;width:100%}.ba-common-richtexteditor .is-validation{visibility:visible}.ba-common-richtexteditor .validation-error{visibility:hidden;display:block;font-size:.75rem;font-weight:600;margin-top:8px;color:#e62325}.ba-common-richtexteditor{transition:opacity .2s ease-in-out}.ba-common-richtexteditor.is-error .validation-error{visibility:visible}\n", ""]);

// exports
exports.locals = {
	"richtexteditorClassName": "\"ba-common-richtexteditor\""
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[438,0]]]);
});